class GalleryLightbox {
  constructor(section) {
    this.items = [...section.querySelectorAll('[data-gallery-src]')];
    if (this.items.length === 0) return;
    this.current = 0;
    this._build();
    this._bind();
  }

  _build() {
    this.lb = document.createElement('div');
    this.lb.className = 'gallery-lightbox';
    this.lb.setAttribute('role', 'dialog');
    this.lb.setAttribute('aria-modal', 'true');
    this.lb.innerHTML = `
      <button class="gallery-lightbox__close" aria-label="Close">&times;</button>
      <button class="gallery-lightbox__prev" aria-label="Previous image">&#8249;</button>
      <div class="gallery-lightbox__content">
        <img class="gallery-lightbox__img" src="" alt="">
        <p class="gallery-lightbox__caption"></p>
      </div>
      <button class="gallery-lightbox__next" aria-label="Next image">&#8250;</button>
    `;
    document.body.appendChild(this.lb);
    this.img = this.lb.querySelector('.gallery-lightbox__img');
    this.caption = this.lb.querySelector('.gallery-lightbox__caption');
  }

  _bind() {
    this.items.forEach((el, i) => el.addEventListener('click', () => this.open(i)));

    this.lb.querySelector('.gallery-lightbox__close').addEventListener('click', () => this.close());
    this.lb.querySelector('.gallery-lightbox__prev').addEventListener('click', () => this.prev());
    this.lb.querySelector('.gallery-lightbox__next').addEventListener('click', () => this.next());

    this.lb.addEventListener('click', (e) => { if (e.target === this.lb) this.close(); });

    document.addEventListener('keydown', (e) => {
      if (!this.lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') this.close();
      if (e.key === 'ArrowLeft') this.prev();
      if (e.key === 'ArrowRight') this.next();
    });
  }

  open(index) {
    this.current = index;
    this._show();
    this.lb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    this.lb.querySelector('.gallery-lightbox__close').focus();
  }

  close() {
    this.lb.classList.remove('is-open');
    document.body.style.overflow = '';
    this.items[this.current].focus();
  }

  prev() {
    this.current = (this.current - 1 + this.items.length) % this.items.length;
    this._show();
  }

  next() {
    this.current = (this.current + 1) % this.items.length;
    this._show();
  }

  _show() {
    const el = this.items[this.current];
    this.img.src = el.dataset.gallerySrc;
    this.img.alt = el.dataset.galleryAlt || '';
    const cap = el.dataset.galleryCaption || '';
    this.caption.textContent = cap;
    this.caption.hidden = !cap;
  }
}

document.querySelectorAll('.gallery-section').forEach((section) => new GalleryLightbox(section));
